import React, { useState, useEffect } from "react";
import BaseVideoTagWrapper from "../BaseWrappers/BaseVideoTagWrapper";
import { ReactComponent as CloseIcon } from "../../assets/actions/close.svg";
import { AspectRatio, Box, Button, Card, Grid } from "@radix-ui/themes";
import { Cross1Icon } from "@radix-ui/react-icons";

const ImageInputPreview: React.FunctionComponent<{
  funcToRemove: () => void;
  file?: File | null;
  url?: string;
}> = ({ funcToRemove, file, url }) => {
  const [preview, setPreview] = useState<string | undefined>(undefined);
  const [type, setType] = useState<string | undefined>(undefined);

  useEffect(() => {
    // create the preview
    if (file) {
      setType(file?.type?.slice(0, 5));
      const objectUrl = URL.createObjectURL(file);

      setPreview(objectUrl);
      // free memory when ever this component is unmounted
      return () => URL.revokeObjectURL(objectUrl);
    }
    setPreview(undefined);
    setType(undefined);
  }, [file]);

  return (
    <Card my="3">
      <Grid columns="6">
        {preview ? (
          type === "video" ? (
            <div className="attachment__video">
              <div className="video">
                <div className="video__content">
                  <BaseVideoTagWrapper videoSrc={preview} />
                </div>
              </div>
            </div>
          ) : (
            <Box position="relative">
              <AspectRatio ratio={1 / 1}>
                <img
                  src={preview || url}
                  alt="Image for upload"
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                    borderRadius: "var(--radius-2)",
                  }}
                />
              </AspectRatio>

              {/* Remove image button */}
              <Box position="absolute" inset="0.25rem 0.25rem auto auto">
                <Button variant="solid" onClick={() => funcToRemove()}>
                  <Cross1Icon />
                </Button>
              </Box>
            </Box>
          )
        ) : (
          ""
        )}
      </Grid>
    </Card>
  );
};

export default ImageInputPreview;
